import { InjectionToken } from '@angular/core';
import { YandexMetrikaAbTestFlagKeys } from '../enum';
import { YandexMetrikaAbTestData } from '../models';

/**
 * Используется для передачи данных эксперимента в сервис яндекс метрики
 */
export const YANDEX_METRIKA_AB_TEST_DATA_TOKEN = new InjectionToken<YandexMetrikaAbTestData>(
  'YandexMetrikaAbTestToken',
);

/**
 * Используется для передачи идентификатора эксперимента в директиву яндекс метрики
 */
export const YANDEX_METRIKA_AB_TEST_EXPERIMENT_ID_TOKEN = new InjectionToken<YandexMetrikaAbTestFlagKeys>(
  'YandexMetrikaAbTestExperimentIdToken',
);
